
const VocabFloatingFilterBar = {
    'availability' : ['Disponibilidad', 'Availability',],
    '' : ['', '',],
  }
  export default VocabFloatingFilterBar;
    